import { Link, useLocation } from "react-router-dom";
import { formatArticleDate } from "@/data/articles";

export const ArticleCard = ({ article, index }) => {
  const { pathname, search } = useLocation();
  return (
  <article data-testid={`article-${article.slug}`}>
    <Link to={`/articles/${article.slug}`} state={{ from: pathname + search }} className="insight-card" data-testid={`article-link-${article.slug}`} aria-labelledby={`article-title-${article.slug}`}>
      <img className="insight-card-image" src={article.image} alt={article.imageAlt} style={{ objectPosition: article.imagePosition }} loading={index < 3 ? "eager" : "lazy"} width="720" height="800" data-testid={`article-image-${article.slug}`} />
      <div className="insight-card-copy">
        <span className="insight-category" data-testid={`article-category-${article.slug}`}>{article.category}</span>
        <div className="insight-card-summary">
          <h2 id={`article-title-${article.slug}`} className="t-h5" data-testid={`article-title-${article.slug}`}>{article.title}</h2>
          <p data-testid={`article-excerpt-${article.slug}`}>{article.excerpt}</p>
        </div>
        <div className="insight-card-meta" data-testid={`article-meta-${article.slug}`}>
          <span className="insight-author-mark" aria-hidden="true">{article.author[0]}</span>
          <span>{article.author}</span><span aria-hidden="true">·</span>
          <time dateTime={article.publishedAt}>{formatArticleDate(article.publishedAt)}</time>
        </div>
      </div>
    </Link>
  </article>
  );
};